import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PlacesAutocomplete from 'react-places-autocomplete';
import { autoCompleteConfig } from '../../constants/addressAutoComplete';
import { extractAddressComponent, convertCoordsWKT } from '../../helpers/addressAutoComplete';
import { errorRequiredText } from '../../constants/text';
import { getGoogleAddressDetails } from '../../actions';
import ErrorMessage from './forms/ErrorMessage';

class AddressInputAutoComplete extends Component {
  static propTypes = {
    noLabel: PropTypes.bool,
    showOnlyAddress: PropTypes.bool,
    isDisabled: PropTypes.bool,
    handleAddressChange: PropTypes.func.isRequired,
    validateAddress: PropTypes.func,
    addressError: PropTypes.bool,
    errorMessage: PropTypes.string,
    addressInfo: PropTypes.shape({
      address: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string
    }),
    getGoogleAddressDetails: PropTypes.func.isRequired
  };

  static defaultProps = {
    addressInfo: {
      address: '',
      state: '',
      city: '',
      zip: '',
      address_coordinates: {}
    }
  };

  handleChange = (address) => {
    this.props.handleAddressChange({ address });
  };

  handleSelect = address => {
    this.props.getGoogleAddressDetails(address).then(
      data => {
        const addressDetails = data.results[0];
        const { address_components } = addressDetails;
        const { lat, lng } = addressDetails.geometry.location;
        const { street_number, street, city, neighborhood, state, zip } = autoCompleteConfig;
        const streetNumber = extractAddressComponent(address_components, street_number);
        const streetName = extractAddressComponent(address_components, street);
        const addressString = (streetNumber + ' ' + streetName).trim();
        const addressInfo = {
          address: addressString,
          city: extractAddressComponent(address_components, city) || extractAddressComponent(address_components, neighborhood),
          state: extractAddressComponent(address_components, state),
          zip: extractAddressComponent(address_components, zip),
          address_coordinates: convertCoordsWKT(lat, lng),
          time_zone_id: data.time_zone_id
        };
        this.props.handleAddressChange(addressInfo, true);
      }
    ).catch(error => console.error('Error', error));
  };

  onInputBlur = () => {
    const { city, state, zip } = this.props.addressInfo;

    if (!city || !state || !zip) {
      this.handleChange(null);
    }

    if (typeof this.props.validateAddress === 'function') {
      this.props.validateAddress();
    }
  };

  render () {
    const { isDisabled, addressInfo, addressError, noLabel, showOnlyAddress } = this.props;
    const { state, city, zip } = addressInfo;
    const address = addressInfo.address || '';
    const searchOptions = {
      types: ['address'],
      componentRestrictions: { country: 'usa' }
    };
    return (
      <React.Fragment>
        <div className='address-item'>
          {!noLabel && <label htmlFor='addressInput'>Address: </label>}
          {isDisabled ? (
            <p>{address}</p>
          ) : (
            <PlacesAutocomplete
              value={address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              googleCallbackName='initGoogleComponents'
              searchOptions={searchOptions}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                <div className='autocomplete-input-wrapper'>
                  <input
                    {...getInputProps({
                      placeholder: 'Search Places ...',
                      className: `address-autocomplete-input ${addressError ? ' error-field' : ''}`,
                      id: 'addressInput',
                      onBlur: this.onInputBlur
                    })}
                  />
                  { addressError && <p className='error-message'>{errorRequiredText}</p> }
                  <ErrorMessage errorText={this.props.errorMessage} />

                  <div className='autocomplete-dropdown-container'>
                    {suggestions.map(suggestion => {
                      const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                      const style = suggestion.active
                        ? { backgroundColor: '#e9ecef', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                      return (
                        <div {...getSuggestionItemProps(suggestion, { className, style })}>
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          )}
        </div>
        {!showOnlyAddress && (
          <p className='address-item'>{city ? `${city}, ` : null}{state ? `${state}, ` : null}{zip || null}</p>
        )}
      </React.Fragment>
    );
  }
}

export default connect(null, { getGoogleAddressDetails })(AddressInputAutoComplete);



// WEBPACK FOOTER //
// ./src/components/common/AddressInputAutoComplete.js